import React from "react";
import { Box } from "@mui/material";
import LevelDevice from "./Devices/LevelDevice";
import parseNumber from "../../../../utils/parseCalculate";
import { useLiveDevice } from "../../../../hooks/useLiveDeviceData";

function Item(props) {
  const { sx, ...other } = props;
  return <Box {...other} />;
}

const TankContainer = (props) => {
  const { data, units, status } = useLiveDevice(
    props.isExpired ? null : props.deviceId,
    { watchStatus: true }
  );
  const deviceStatus = props.isExpired ? "inactive" : status;
  const levelValue = data ? parseNumber(data.level) : "--";

  return (
    <Item>
      <LevelDevice
        deviceStatus={deviceStatus}
        deviceId={props.deviceId}
        lastUpdatedDate={
          props.isExpired
            ? ""
            : data?.date_time &&
              new Date(data.date_time).toLocaleDateString("en-GB").slice(0, 10)
        }
        lastUpdatedTime={
          props.isExpired
            ? ""
            : data?.date_time &&
              new Date(data.date_time).toLocaleTimeString("en-US", {
                hour12: true,
              })
        }
        levelValue={
          props.isExpired
            ? "Subscription Expired"
            : `${levelValue} (${units.level_unit || ""})`
        }
        title={props.name}
      />
    </Item>
  );
};

export default TankContainer;
